<template>
  <BaseLayout>
    <SubHeader></SubHeader>
    <h2 class="text-center page-heading">MEET THE TEAM</h2>
    <div class="container">
      <div class="row mb-4">
        <div class="col">
          <h4 style="margin-bottom: 16px;">Mane Street Market = Marketplace for sales horses and equine services.</h4>
          <p style="line-height: 1.8;">Mane Street Market is a marketing platform for equestrians to market their sales horses and showcase their equine services.  Our goal is to streamline the search process for sales horses and equine services through our website <a href="https://manestreetmarket.com/">www.manestreetmarket.com</a> and the free app on Apple and Google Play.</p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card-deck mb-3">
            <div class="card mb-4 box-shadow person-card">
              <div class="card-body team-card">
                <img class="img-headshot" src="../assets/img/india_headshot.jpg" />
                <h2 class="card-title pricing-card-title">India Wilkinson</h2>
                <div class="row position-title-row">
                  <span>CEO</span><a class="email-link" href="mailto:support@manestreetauctions.com"><img src="../assets/img/icon_email.png" /></a>
                </div>
                <h6>Atlanta, Georgia and Vero Beach, Florida</h6>
                <p id="india-bio" class="clamped">India is a lifelong horse owner/competitor and has decades of experience in the marketing/sales industry with the last 15 years specifically in the equestrian marketing arena. India offers her expertise in helping sellers market their sales horses and buyers find their new equine partner through Mane Street Market. Her vision is to match up buyers and sellers on a premium online platform. India can be reached at <a href="mailto:support@manestreetmarket.com">support@manestreetmarket.com</a>.</p>       
                <button class="read-more-button" id="india-bio-button" @click="() => removeClamped('india-bio')">Read more</button>
              </div>
            </div>
            <div class="card mb-4 box-shadow person-card">
              <div class="card-body team-card">
                <img class="img-headshot" src="../assets/img/aqua_headshot.jpg" />
                <h2 class="card-title pricing-card-title">Aqua Rask</h2>
                <div class="row position-title-row">
                  <span>Sales Director - West Coast</span>
                </div>
                <p id="aqua-bio" class="clamped">Aqua is a USDF silver medalist located in San Diego, CA. She is an accomplished rider/trainer with a successful career training horses and helping her clients achieve their goals. Aqua is an essential part of the team helping to grow Mane Street Market on the West Coast and increasing awareness in the Dressage community overall.</p>       
                <button class="read-more-button" id="aqua-bio-button" @click="() => removeClamped('aqua-bio')">Read more</button>
              </div>
            </div>
            <div class="card mb-4 box-shadow person-card">
              <div class="card-body team-card">
                <img class="img-headshot" src="../assets/img/holly_headshot.jpg" />
                <h2 class="card-title pricing-card-title">Holly Chow</h2>
                <div class="row position-title-row">
                  <span>Sales Director Canada</span>
                </div>
                <p id="holly-bio" class="clamped">Holly is responsible for growing MSM in all of Canada as well as some of the bordering US states. She has extensive experience in the Quarter Horse world so she will also be building our network in the Western disciplines in the US and Canada. She has a strong background in sales and marketing which makes her the perfect addition to our awesome team!</p>       
                <button class="read-more-button" id="holly-bio-button" @click="() => removeClamped('holly-bio')">Read more</button>
              </div>
            </div>
          </div>
          <div class="card-deck mb-3">
            <div class="card mb-4 box-shadow person-card">
              <div class="card-body team-card">
                <img class="img-headshot" src="../assets/img/bri_headshot.jpg" />
                <h2 class="card-title pricing-card-title">Bri Manning</h2>
                <div class="row position-title-row">
                  <span>Marketing Intern</span>
                </div>
                <p id="bri-bio" class="clamped">Bri is a sophomore at Virginia Tech and continues to compete her horses up the levels in eventing while attending class and working. Bri has been integral to promoting the Mane Street Market horses on social media and growing awareness on the East Coast.</p>       
                <button class="read-more-button" id="bri-bio-button" @click="() => removeClamped('bri-bio')">Read more</button>
              </div>
            </div>
            <div class="card mb-4 box-shadow person-card">
              <div class="card-body team-card">
                <img class="img-headshot" src="../assets/img/vicky_headshot.jpg" />
                <h2 class="card-title pricing-card-title">Vicky Vivaldi</h2>
                <div class="row position-title-row">
                  <span>Marketing Intern</span>
                </div>
                <p id="vicky-bio" class="clamped">Vicky is a senior at the University of Florida studying Equine Science. She has a lifelong background in the hunter/jumpers and works with a sales barn in Ocala. Vicky will be focusing on Mane Street Market's growth in the hunter/jumper discipline and helping to expand our presence on social media.</p>       
                <button class="read-more-button" id="vicky-bio-button" @click="() => removeClamped('vicky-bio')">Read more</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<style lang="scss">
.page-heading {
  margin: -40px 0 48px;
  padding: 32px 0 40px;
  background-color: #141645;
  color: white;
}

.card-deck {
  justify-content: center;
}

.card-deck.vertical-deck {
  flex-direction: column;
}

.person-card {
  max-width: calc(33.33% - 30px);
}

.team-card {
  .img-headshot {
    width: calc(100% + 2.5rem);
    height: 400px;
    object-fit: cover;
    object-position: top;
    margin: -1.25rem -1.25rem 1.25rem;
  }

  .position-title-row {
    margin-left: 0;
    margin-bottom: 8px;
  }

  .email-link {
    padding: 4px;
    display: inline-flex;
    border: 1px solid lightgray;
    border-radius: 50%;
    margin-left: 8px;
    img {
      opacity: 0.4;
      width: 16px;
      height: 16px;
    }
  }

  .clamped {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .read-more-button {
    border: none;
    background: none;
    outline: none;
    box-shadow: none;
    padding: 0;
    color: #0A1369;
    text-decoration: underline;
    display: inline;
  }
}

@media screen and (max-width: 480px) {
  .page-heading {
    margin-bottom: 24px;
  }

  .person-card {
    max-width: 100%;
  }
}
</style>

<script>
import BaseLayout from '@/layouts/Base.vue';
import SubHeader from "@/components/SubHeader.vue";

export default {
  components: {BaseLayout, SubHeader},
  mounted() {
    document.title = 'About - Mane Street Market';
    window.scrollTo(0, 0);
  },
  methods: {
    removeClamped(id) {
      const p = document.querySelector(`#${id}`);
      const btn = document.querySelector(`#${id}-button`);
      p.classList.toggle('clamped');
      if (p.classList.contains('clamped')) {
        btn.textContent = 'Read more';
      } else {
        btn.textContent = 'Read less';
      }
    }
  }
}
</script>